import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Grid from "@material-ui/core/Grid";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Select from "react-select";
import swal from "sweetalert";
import axios from "axios";
import TextField from "@material-ui/core/TextField";
import DateBox from "devextreme-react/date-box";
import "../../modal.css";
import { api_path } from "../../shared";
function EditOrderModal(props) {
  const [REMARK, SET_REMARK] = useState("");
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [GET_ORDER_NO, SET_ORDER_NO] = useState("");
  const [GET_QUOTATION_NO, SET_QUOTATION_NO] = useState("");
  const [GET_ORDER_STATUS_ID, SET_ORDER_STATUS_ID] = useState("");
  const [GET_ORDER_STATUS_NAME, SET_ORDER_STATUS_NAME] = useState("");
  const [GET_CUSTOMER_REF, SET_CUSTOMER_REF] = useState("");
  const [GET_CNT20, SET_CNT20] = useState("");
  const [GET_TYPE20, SET_TYPE20] = useState("");
  const [GET_CNT40, SET_CNT40] = useState("");
  const [GET_TYPE40, SET_TYPE40] = useState("");
  const [GET_CNT40HQ, SET_CNT40HQ] = useState("");
  const [GET_TYPE40HQ, SET_TYPE40HQ] = useState("");
  const [GET_CNT45, SET_CNT45] = useState("");
  const [GET_TYPE45, SET_TYPE45] = useState("");

  const [isRejectButtonDisabled, setRejectButtonDisabled] = useState(true);
  const [getOrderStatus, setOrderStatus] = useState([]);
  const [orderStatusList, setOrderStatusList] = useState([]);
  const [selectOrderStatus, setSelectOrderStatus] = useState([]);
  const optionsContainerType = [
    { value: "DC", label: "DC" }, //Dry Container
    { value: "FR", label: "FR" }, //Flat Rack Container
    { value: "OT", label: "OT" }, //Open Top Container
    { value: "RF", label: "RF" }, //Reefer Container
    { value: "BULK", label: "BULK" },
    { value: "TANK", label: "TANK" }, //Tank Container
    { value: "HC", label: "HC" },
    { value: "SOC", label: "SOC" },
  ];
  const now = new Date();
  const dateLabel = { "aria-label": "Date" };
  var date = new Date();
  var today = new Date(date.getFullYear(), date.getMonth(), date.getDate());
  var lastDay = new Date(date.getFullYear(), date.getMonth() + 2, 0);
  const formattedtoday = today
    .toLocaleDateString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    })
    .split("/")
    .reverse()
    .join("-");
  const [GET_ORDER_DATE, SET_ORDER_DATE] = useState(formattedtoday);
  const [getCargoReady, setCargoReady] = useState(null);
  const [getCyDate, setCyDate] = useState(null);
  const [getReturnDate, setReturnDate] = useState(null);
  const [getEtdDate, setEtdDate] = useState(null);
  const [getEtaDate, setEtaDate] = useState(null);
  const onValueChangedCargoReady = React.useCallback((e) => {
    if (e.value) {
      const dateFrom = new Date(e.value);
      const formattedDateFrom = dateFrom
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setCargoReady(formattedDateFrom);
    } else {
      setCargoReady(null);
    }
  }, []);
  const onValueChangedCyDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setCyDate(formattedDateTo);
    } else {
      setCyDate(null);
    }
  }, []);
  const onValueChangedReturnDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setReturnDate(formattedDateTo);
    } else {
      setReturnDate(null);
    }
  }, []);
  const onValueChangedEtdDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setEtdDate(formattedDateTo);
    } else {
      setEtdDate(null);
    }
  }, []);
  const onValueChangedEtaDate = React.useCallback((e) => {
    if (e.value) {
      const dateTo = new Date(e.value);
      const formattedDateTo = dateTo
        .toLocaleDateString("en-GB", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        .split("/")
        .reverse()
        .join("-");
      setEtaDate(formattedDateTo);
    } else {
      setEtaDate(null);
    }
  }, []);
  useEffect(() => {
    let order_status = props.ORDER_STATUS;
    if (
      order_status == "0" ||
      order_status == "3" ||
      order_status == "4" ||
      order_status == "5" ||
      order_status == "6" ||
      order_status == "7" ||
      order_status == "8" ||
      order_status == "9"
    ) {
      setRejectButtonDisabled(false);
      setRejectButtonDisabled(false);
    } else {
      setRejectButtonDisabled(true);
    }
    SET_CUSTOMER_REF(props.CUSTOMER_REF);
    SET_QUOTATION_NO(props.QUOTATION_NO);
    SET_CNT20(props.CNT20);
    SET_TYPE20(props.TYPE20);
    SET_CNT40(props.CNT40);
    SET_TYPE40(props.TYPE40);
    SET_CNT40HQ(props.CNT40HQ);
    SET_TYPE40HQ(props.TYPE40HQ);
    SET_CNT45(props.CNT45);
    SET_TYPE45(props.TYPE45);
    setCargoReady(props.CARGO_READY);
    setEtaDate(props.ETA_DATE);
    setEtdDate(props.ETD_DATE);
    setCyDate(props.CY_DATE);
    setReturnDate(props.RETURN_DATE);
  }, []);
  const [errors, setErrors] = useState({});
  const validateForm = () => {
    const errors = {};
    if (!GET_QUOTATION_NO) {
      errors.quotation = "Please fill Quotation NO.";
    }
    if (!GET_CNT20 && !GET_CNT40 && !GET_CNT40HQ && !GET_CNT45) {
      errors.volume = "Please input volume";
    }
    let count = GET_CNT20 + GET_CNT40 + GET_CNT40HQ + GET_CNT45;
    if (count == 0) {
      errors.volume = "Please input volume";
    }
    if (GET_CNT20 && GET_CNT20 > 0 && !GET_TYPE20) {
      errors.volume20 = "Please input type 20'";
    }
    if (GET_CNT40 && GET_CNT40 > 0 && !GET_TYPE40) {
      errors.volume40 = "Please input type 40'";
    }
    if (GET_CNT45 && GET_CNT45 > 0 && !GET_TYPE45) {
      errors.volume45 = "Please input type 45'";
    }
    if (GET_CNT40HQ && GET_CNT40HQ > 0 && !GET_TYPE40HQ) {
      errors.volume40HQ = "Please input type 40HQ";
    }
    if (
      !getCargoReady &&
      !getCyDate &&
      !getReturnDate &&
      !getEtdDate &&
      !getEtaDate
    ) {
      errors.etdDate =
        "Please input Cargo ready or CY date or Return date or ETD date or ETA date";
    }
    return errors;
  };
  // function onSubmitForm(ORDER_ID) {
  //   swal({
  //     title: "Do you want to save the changes?",
  //     text: "",
  //     icon: "info",
  //     dangerMode: false,
  //     buttons: true,
  //     buttons: [
  //       'Save data only',
  //       'Save data and Send Order'
  //     ],
  //   }).then((isConfirm) => {
  //     if (isConfirm) {
  //       updateOrderDetail(ORDER_ID,1);
  //     }else{
  //       updateOrderDetail(ORDER_ID,2);
  //     }
  //   });
  // }
  function updateOrderDetail(ORDER_ID) {
    const newErrors = validateForm();
    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      //alert("Invalid")
    } else {
      var data = {
        ORDER_ID: ORDER_ID,
        QUOTATION_NO: GET_QUOTATION_NO,
        CUSTOMER_REF: GET_CUSTOMER_REF,
        CARGO_READY: getCargoReady,
        CY_DATE: getCyDate,
        RETURN_DATE: getReturnDate,
        ETD_DATE: getEtdDate,
        ETA_DATE: getEtaDate,
        CNT20: GET_CNT20,
        TYPE20: GET_TYPE20,
        CNT40: GET_CNT40,
        TYPE40: GET_TYPE40,
        CNT40HQ: GET_CNT40HQ,
        TYPE40HQ: GET_TYPE40HQ,
        CNT45: GET_CNT45,
        TYPE45: GET_TYPE45,
      };
      fetch(api_path + "/TS_SALES_ORDER_UPDATE.php", {
        method: "POST",
        headers: {
          Accept: "application/form-data",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((result) => {
          if (result["status"] == "200") {
            swal("Done.", "Update data successfully.", "success", {
              buttons: true,
              timer: 5000,
            }).then(function () {
              // if(FLAG===1){
              //   //alert("111")
              //   const url =
              //   api_path +
              //   "/SENDMAIL_SALESORDER.php?order_id=" +
              //   ORDER_ID +
              //   "&order_status=1";
              // axios
              //   .get(url)
              //   .then((response) => {
              //     // handle success
              //     console.log("Send mail successfully"+ORDER_ID);
              //   })
              //   .then((data) => {
              //     console.log(data);
              //     // Handle data
              //   })
              //   .catch((error) => {
              //     // handle errors
              //     console.log("Send mail unsuccessfully");
              //   });
              // }else{
              //   //alert("222")
              // }
              handleClose();
              window.location.reload();
            });
          } else {
            swal("Sorry", result["message"], "error", {
              buttons: true,
              timer: 5000,
            });
          }
        });
    }
  }
  const STYLES = {
    "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot":
      {
        padding: "3px !important",
        fontSize: "14px",
        color: "#000000",
      },
    "&.MuiAutocomplete-root": {
      padding: "0px",
    },
  };
  return (
    <>
      <button className="btn btn-primary btn-sm" onClick={handleShow}>
        Edit
      </button>

      <Modal
        className="modal"
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Order NO. {props.ORDER_NO}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              updateOrderDetail(props.ORDER_ID);
            }}
            id="editmodal"
            className=""
          >
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}></Grid>
              <input type="hidden" value={props.ORDER_ID} />

              <Grid item xs={12} sm={3}>
                <label>
                  QUOTATION NO <span className="required">*</span>
                </label>
                <TextField
                  size="small"
                  name="GET_QUOTATION_NO"
                  variant="outlined"
                  fullWidth
                  id="GET_QUOTATION_NO"
                  value={GET_QUOTATION_NO}
                  onChange={(e) => SET_QUOTATION_NO(e.target.value)}
                />
                {errors.quotation && (
                  <span className="error-message">{errors.quotation}</span>
                )}
              </Grid>
              <Grid item xs={12} sm={3}>
                <label>CUSTOMER REF</label>
                <TextField
                  size="small"
                  name="GET_CUSTOMER_REF"
                  variant="outlined"
                  fullWidth
                  id="GET_CUSTOMER_REF"
                  value={GET_CUSTOMER_REF}
                  onChange={(e) => SET_CUSTOMER_REF(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={3}></Grid>
              <Grid item xs={12} sm={3}></Grid>
              <Grid item xs={12} sm={2}>
                <label>CARGO READY</label>
                <DateBox
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  inputAttr={dateLabel}
                  type="date"
                  displayFormat="dd/MM/yyyy"
                  value={getCargoReady}
                  onValueChanged={onValueChangedCargoReady}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <label>CY DATE</label>
                <DateBox
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  inputAttr={dateLabel}
                  type="date"
                  displayFormat="dd/MM/yyyy"
                  value={getCyDate}
                  onValueChanged={onValueChangedCyDate}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <label>RETURN DATE</label>
                <DateBox
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  inputAttr={dateLabel}
                  type="date"
                  displayFormat="dd/MM/yyyy"
                  value={getReturnDate}
                  onValueChanged={onValueChangedReturnDate}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <label>ETD DATE</label>

                <DateBox
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  //hint="ESTIMATE TIME OF DEPARTURE = ประมาณการของวันที่ที่เรือจะออกจากท่าต้นทาง"
                  inputAttr={dateLabel}
                  type="date"
                  displayFormat="dd/MM/yyyy"
                  value={getEtdDate}
                  onValueChanged={onValueChangedEtdDate}
                />
              </Grid>
              <Grid item xs={12} sm={2}>
                <label>ETA DATE</label>
                <DateBox
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                  }}
                  //hint="ESTIMATE TIME OF ARRIVAL = ประมาณการของวันที่ที่เรือจะเข้าถึงท่าปลายทาง"
                  inputAttr={dateLabel}
                  type="date"
                  displayFormat="dd/MM/yyyy"
                  value={getEtaDate}
                  onValueChanged={onValueChangedEtaDate}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                {errors.etdDate && (
                  <span className="error-message">{errors.etdDate}</span>
                )}
                {errors.etdDate && (
                  <span className="error-message">{errors.etdDate}</span>
                )}
              </Grid>

              <Grid item xs={12} className="fixpadding-bottom">
                <label className="head3">VOLUME</label>
                {errors.volume && (
                  <span className="error-message">{errors.volume}</span>
                )}
              </Grid>

              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>20'</label>
                <TextField
                  size="small"
                  name="GET_CNT20"
                  variant="outlined"
                  fullWidth
                  id="GET_CNT20"
                  value={GET_CNT20}
                  onChange={(e) => SET_CNT20(e.target.value)}
                  inputProps={{ min: 0 }}
                />
              </Grid>

              {/* )} */}

              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>TYPE 20'</label>
                <Autocomplete
                  id="free-solo-demo"
                  GET_TYPE20
                  name="GET_TYPE20"
                  value={GET_TYPE20}
                  options={optionsContainerType}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      SET_TYPE20(newValue.value);
                    } else {
                      SET_TYPE20("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" fullWidth />
                  )}
             
                />
              </Grid>
              {/* )} */}
              {errors.volume20 && (
                <Grid item xs={12} sm={12}>
                  <span className="error-message">{errors.volume20}</span>
                </Grid>
              )}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>40'</label>
                <TextField
                  size="small"
                  name="GET_CNT40"
                  variant="outlined"
                  fullWidth
                  id="GET_CNT40"
                  value={GET_CNT40}
                  onChange={(e) => SET_CNT40(e.target.value)}
                />
              </Grid>
              {/* )} */}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>TYPE 40'</label>
                <Autocomplete
                  id="free-solo-demo"
                  GET_TYPE40
                  name="GET_TYPE40"
                  value={GET_TYPE40}
                  options={optionsContainerType}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      SET_TYPE40(newValue.value);
                    } else {
                      SET_TYPE40("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" fullWidth />
                  )}
                  sx={{
                    Height: "20px",
                    ...STYLES,
                  }}
                />
              </Grid>
              {errors.volume40 && (
                <Grid item xs={12} sm={12}>
                  <span className="error-message">{errors.volume40}</span>
                </Grid>
              )}
              {/* )} */}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>40 HQ'</label>
                <TextField
                  size="small"
                  name="GET_CNT40HQ"
                  variant="outlined"
                  fullWidth
                  id="GET_CNT40HQ"
                  value={GET_CNT40HQ}
                  onChange={(e) => SET_CNT40HQ(e.target.value)}
                />
              </Grid>
              {/* )} */}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>TYPE 40HQ'</label>
                <Autocomplete
                  id="free-solo-demo"
                  GET_TYPE40HQ
                  name="GET_TYPE40HQ"
                  value={GET_TYPE40HQ}
                  options={optionsContainerType}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      SET_TYPE40HQ(newValue.value);
                    } else {
                      SET_TYPE40HQ("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" fullWidth />
                  )}
                  sx={{
                    Height: "20px",
                    ...STYLES,
                  }}
                />
              </Grid>
              {errors.volume40HQ && (
                <Grid item xs={12} sm={12}>
                  <span className="error-message">{errors.volume40HQ}</span>
                </Grid>
              )}
              {/* )} */}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>45'</label>
                <TextField
                  size="small"
                  name="GET_CNT45"
                  variant="outlined"
                  fullWidth
                  id="GET_CNT45"
                  value={GET_CNT45}
                  onChange={(e) => SET_CNT45(e.target.value)}
                />
              </Grid>
              {/* )} */}
              {/* {showFCL && ( */}
              <Grid item xs={12} sm={3}>
                <label>TYPE 45'</label>
                <Autocomplete
                  id="free-solo-demo"
                  GET_TYPE45
                  name="GET_TYPE45"
                  value={GET_TYPE45}
                  options={optionsContainerType}
                  onChange={(event, newValue) => {
                    if (newValue) {
                      SET_TYPE45(newValue.value);
                    } else {
                      SET_TYPE45("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField {...params} variant="outlined" fullWidth />
                  )}
                  sx={{
                    Height: "20px",
                    ...STYLES,
                  }}
                />
              </Grid>
              {errors.volume45 && (
                <Grid item xs={12} sm={12}>
                  <span className="error-message">{errors.volume45}</span>
                </Grid>
              )}
              {/* )} */}
            </Grid>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-secondary" onClick={handleClose}>
            Close
          </button>
          <button className="btn btn-primary " form="editmodal">
            Save
          </button>
          {/* <button className="btn btn-primary green" form="editmodal">
            Send Order
          </button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default EditOrderModal;
